import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveUser } from "../context/userReducer";
import { savePartnerships } from "../context/partnershipsReducer";

export const useLoginUser = ({ password, mail }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [response, setResponse] = useState();
    const [loading, setLoading] = useState(false);

    const checkUserExists = async (e) => {
        e.preventDefault();

        if (!mail || !password) return;

        setLoading(true);
        try {
            const res = await fetch("https://parasha.iyun.co.il/api/" + "partnership/IsUserExists", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mail, password }),
            });
            const data = await res.json();
            setLoading(false);

            setResponse(data.status);
            if (data.status === 1) {
                if (data.partnershipsDetailes.length === 1) {
                    dispatch(saveUser(data.partnershipsDetailes[0]));
                    navigate("/fill");
                } else {
                    dispatch(savePartnerships(data.partnershipsDetailes));
                    navigate("/choose");
                }
            }
        } catch (error) {
            alert("נתקלנו בבעיה");
            setLoading(false);
        }
    };

    return { loading, response, checkUserExists }
};